import { CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'
import { QueryKey } from '@tanstack/react-query'
import { z } from 'zod'

import { normalizedNumberSchema } from '@/domain/common/validation'

export interface SnapshotVotingPowerParams {
  account: CheckedAddress | undefined
}

export interface SnapshotVotingPowerResult {
  votingPower: NormalizedNumber
}

export function snapshotVotingPowerQueryKey({ account }: SnapshotVotingPowerParams): QueryKey {
  return ['spk-governance', 'voting-power', account]
}

export async function snapshotVotingPowerQueryFn({
  account,
}: SnapshotVotingPowerParams): Promise<SnapshotVotingPowerResult> {
  if (!account) {
    return {
      votingPower: NormalizedNumber.ZERO,
    }
  }

  const res = await fetch('https://hub.snapshot.org/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
      query Vp($voter: String!, $space: String!) {
       vp(voter: $voter, space: $space) {
        vp
        vp_by_strategy
       }
      }
     `,
      variables: {
        voter: account,
        space: 'sparkfi.eth',
      },
    }),
  })

  if (!res.ok) {
    throw new Error('Failed to fetch voting power')
  }

  const data = await res.json()
  const parsed = votingPowerSchema.parse(data)

  return parsed.data
}

const votingPowerSchema = z.object({
  data: z
    .object({
      vp: z.object({
        vp: normalizedNumberSchema,
      }),
    })
    .transform(({ vp }) => ({
      votingPower: vp.vp,
    })),
})
